import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Sidebar from '../components/sidebar/sidebar';
import { useTranslation } from 'react-i18next';
import FloatingLanguageToggle from '../components/common/FloatingLanguageToggle';

export default function Layout({ children }) {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  
  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#fff7f0',
        flexDirection: { xs: 'column', md: isRTL ? 'row-reverse' : 'row' }
      }}
    >
      {/* Floating Language Toggle - appears on all pages */}
      <FloatingLanguageToggle />
      {/* Sidebar */}
          <Box
            component="aside"
            sx={{
              width: { xs: '100%', md: '16vw' },
              flexShrink: 0,
              backgroundColor: '#f8f9fa',
              position: { md: 'fixed' },
              height: { md: '100vh' },
              [isRTL ? 'right' : 'left']: { md: 0 },
              zIndex: { md: 1 },
              direction: isRTL ? 'rtl' : 'ltr'
            }}
          >
        <Sidebar />
      </Box>

      {/* Main Content */}
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              padding: { xs: '16px', sm: '20px' },
              backgroundColor: '#fff7f0',
              marginLeft: { md: isRTL ? 0 : '16vw' },
              marginRight: { md: isRTL ? '16vw' : 0 },
              width: { md: 'calc(100% - 16vw)' },
              direction: isRTL ? 'rtl' : 'ltr',
              textAlign: isRTL ? 'right' : 'left'
            }}
          >
        {children}
      </Box>
    </Box>
  );
}